import { OrderingInitialState, SetPaymentTypeAction } from '@reducers/ordering/types';

export const setPaymentType = (state: OrderingInitialState, action: SetPaymentTypeAction): OrderingInitialState => ({
  ...state,
  orderState: {
    ...state.orderState,
    paymentType: action.payload,
  },
});
